/**
 * @generated SignedSource<<b35c66124b8aa5ba945a8ce007846f3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetails_item$data = {
  readonly pdpDetailsDisplay: ReadonlyArray<{
    readonly delimiter: string | null;
    readonly detailDisplayName: string | null;
    readonly detailKey: string | null;
    readonly detailValues: ReadonlyArray<{
      readonly __typename: string;
      readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetail_detailValues" | "PdpSharedRingSizeDetail_detailValues">;
    } | null> | null;
  } | null> | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailFramingOptions_item" | "PdpSharedDetailReference_item">;
  readonly " $fragmentType": "PdpRespDetails_item";
};
export type PdpRespDetails_item$key = {
  readonly " $data"?: PdpRespDetails_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetails_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetails_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PdpDetail",
      "kind": "LinkedField",
      "name": "pdpDetailsDisplay",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "detailKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "delimiter",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "detailDisplayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "detailValues",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedDetail_detailValues"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedRingSizeDetail_detailValues"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailFramingOptions_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReference_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "f2f65a1f5501f52ac9eb25bae5b8143d";

export default node;
